import "arrive";
import $ from 'jquery';

document.arrive(".block-posizioni-lavorative",{ existing: true }, function (el) {
    const $form = $('#posizioni-filter');
    const $results = $('#posizioni-results');

    const ajaxUrl = $results.data('ajax-url');
    const nonce = $results.data('nonce');

    $form.on('change', 'select', function() {
        const data = {
            action: 'filter_posizioni',
            area_lavorativa: $form.find('[name="area_lavorativa"]').val(),
            regione: $form.find('[name="regione"]').val(),
            contratto: $form.find('[name="contratto"]').val(),
            nonce: nonce
        };

        // Fade out prima di fare la richiesta
        $results.fadeTo(200, 0.5, function() {
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: data,
                beforeSend: function() {
                    // opzionale: mostra un loader sopra il contenuto attuale
                    $results.addClass('loading');
                },
                success: function(response) {
                    if (response.success) {
                        // Aggiorna contenuto e fai fade in
                        $results.html(response.data).fadeTo(300, 1, function() {
                            $results.removeClass('loading');
                        });
                    }
                },
                error: function() {
                    $results.removeClass('loading').fadeTo(300, 1);
                }
            });
        });
    });



    $('.block-posizioni-lavorative__default-application')
        .on('mouseenter', function() {
            $('.posizione-lavorativa-item:last .posizione-lavorativa-item__wrapper')
                .css('border-bottom-color', 'white');
        })
        .on('mouseleave', function() {
            $('.posizione-lavorativa-item:last .posizione-lavorativa-item__wrapper')
                .css('border-bottom-color', '');
    });

});
